import { createFileRoute } from '@tanstack/react-router'
import { CoursePage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/it/corsi/$courseSlug/')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'course', locale: 'it', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { courseSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <CoursePage courseSlug={courseSlug} />
    </CatalogProvider>
  )
}
